/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { Fragment, type FunctionComponent } from 'react'

import { EuiButton, EuiCallOut, EuiSpacer } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

const LoadingError: FunctionComponent = () => {
  const onRefreshPage = () => window.location.reload()

  return (
    <EuiCallOut
      color='danger'
      iconType='warning'
      title={
        <FormattedMessage
          id='billing.notifications.budgets.edit-budget.error-loading.title'
          defaultMessage='We could not load your budget'
        />
      }
    >
      <Fragment>
        <FormattedMessage
          id='billing.notifications.budgets.edit-budget.error-loading.description'
          defaultMessage='There was an error loading the Budget. Wait 1 minute and try again. If this keeps happening, contact your administrator.'
        />

        <EuiSpacer size='m' />

        <EuiButton type='button' color='danger' onClick={onRefreshPage}>
          <FormattedMessage
            id='billing.notifications.budgets.edit-budget.error-loading.button'
            defaultMessage='Try again'
          />
        </EuiButton>
      </Fragment>
    </EuiCallOut>
  )
}

export default LoadingError
